/**
 * Formatting Utilities - Display formatting helpers
 * @module utils/format
 */

/**
 * Format seconds into a human-readable time string.
 * Examples: "5 s", "1 min 30 s", "2 min" -- written as French writes them.
 */
export function formatTime(seconds: number): string {
	if (seconds < 60) {
		return `${Math.round(seconds)} s`;
	}
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = Math.round(seconds % 60);
	if (remainingSeconds === 0) {
		return `${minutes} min`;
	}
	return `${minutes} min ${remainingSeconds} s`;
}
